import '@/instrument'

import * as React from 'react'
import * as ReactDOM from 'react-dom/client'
import * as Sentry from '@sentry/react'
import { createRoutesFromElements, createBrowserRouter, Route } from 'react-router'
import { RouterProvider } from 'react-router/dom'
import { NuqsAdapter } from 'nuqs/adapters/react-router/v7'
import { SubscriptionBranch } from '@/pages/subscription/branch/index'
import { SubscriptionBranchHowto } from '@/pages/subscription/branch/howto/index'
import { SubscriptionBranchNew, loader as subscriptionBranchNewLoader } from '@/pages/subscription/branch/new/index'
import { SubscriptionBranchSubscribed, loader as subscriptionBranchSubscribedLoader } from '@/pages/subscription/branch/subscribed/index'
import { SubscriptionBranchLogin, loader as subscriptionBranchLoginLoader } from '@/pages/subscription/branch/login/index'
import { SubscriptionBranchMypageLayout, loader as mypageLayoutLoader } from '@/pages/subscription/branch/mypage/index'
import { SubscriptionBranchMypageTop, loader as subscriptionBranchTopLoader } from '@/pages/subscription/branch/mypage/top/index'
import { SubscriptionBranchMypageSkip, loader as subscriptionBranchSkipLoader } from '@/pages/subscription/branch/mypage/skip/index'
import { SubscriptionBranchMypageSchedule, loader as subscriptionBranchScheduleLoader } from '@/pages/subscription/branch/mypage/schedule/index'
import { SubscriptionBranchMypageAddress, loader as subscriptionBranchAddressLoader } from '@/pages/subscription/branch/mypage/address/index'
import { SubscriptionBranchMypageCancel, loader as subscriptionBranchCancelLoader } from '@/pages/subscription/branch/mypage/cancel/index'
import { SubscriptionBranchMypageCard } from '@/pages/subscription/branch/mypage/card/index'
import { SubscriptionBranchMypageEmail } from '@/pages/subscription/branch/mypage/email/index'
import { SubscriptionBranchMypagePassword } from '@/pages/subscription/branch/mypage/password/index'
import { SubscriptionBranchMypageDelete, loader as subscriptionBranchDeleteLoader } from '@/pages/subscription/branch/mypage/delete/index'

import '@fontsource-variable/noto-sans-jp'
import '@fontsource-variable/inter'
import '@/styles/subscription-branch.tailwind.css'

const ErrorPage = () => <></>

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" errorElement={<ErrorPage />}>
      <Route path="subscription/branch" element={<SubscriptionBranch />} />
      <Route path="subscription/branch/howto" element={<SubscriptionBranchHowto />} />
      <Route path="subscription/branch/new" element={<SubscriptionBranchNew />} loader={subscriptionBranchNewLoader} />
      <Route path="subscription/branch/subscribed" element={<SubscriptionBranchSubscribed />} loader={subscriptionBranchSubscribedLoader} />
      <Route path="subscription/branch/login" element={<SubscriptionBranchLogin />} loader={subscriptionBranchLoginLoader} />
      <Route element={<SubscriptionBranchMypageLayout />} loader={mypageLayoutLoader} id={'mypageLayout'}>
        <Route path="subscription/branch/mypage" element={<SubscriptionBranchMypageTop />} loader={subscriptionBranchTopLoader} />
        <Route path="subscription/branch/mypage/skip" element={<SubscriptionBranchMypageSkip />} loader={subscriptionBranchSkipLoader} />
        <Route path="subscription/branch/mypage/schedule" element={<SubscriptionBranchMypageSchedule />} loader={subscriptionBranchScheduleLoader} />
        <Route path="subscription/branch/mypage/address" element={<SubscriptionBranchMypageAddress />} loader={subscriptionBranchAddressLoader} />
        <Route path="subscription/branch/mypage/cancel" element={<SubscriptionBranchMypageCancel />} loader={subscriptionBranchCancelLoader} />
        <Route path="subscription/branch/mypage/card" element={<SubscriptionBranchMypageCard />} />
        <Route path="subscription/branch/mypage/email" element={<SubscriptionBranchMypageEmail />} />
        <Route path="subscription/branch/mypage/password" element={<SubscriptionBranchMypagePassword />} />
        <Route path="subscription/branch/mypage/delete" element={<SubscriptionBranchMypageDelete />} loader={subscriptionBranchDeleteLoader} />
      </Route>
    </Route>,
  ),
)

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<ErrorPage />}>
      <NuqsAdapter>
        <RouterProvider router={router} />
      </NuqsAdapter>
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
)
